/* tslint:disable */
/* eslint-disable */
/**
 * referral-network
 * referral-network
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DirectoryContact } from './DirectoryContact';
import {
    DirectoryContactFromJSON,
    DirectoryContactFromJSONTyped,
    DirectoryContactToJSON,
    DirectoryContactToJSONTyped,
} from './DirectoryContact';

/**
 * 
 * @export
 * @interface ListDirectoryContactsResponse
 */
export interface ListDirectoryContactsResponse {
    /**
     * True when the provider is external (non-ExaCare); false for an internal ExaCare facility.
     */
    is_external: boolean;
    /**
     * 
     */
    data: Array<DirectoryContact>;
}

/**
 * Check if a given object implements the ListDirectoryContactsResponse interface.
 */
export function instanceOfListDirectoryContactsResponse(value: object): value is ListDirectoryContactsResponse {
    if (!('is_external' in value) || value['is_external'] === undefined) return false;
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function ListDirectoryContactsResponseFromJSON(json: any): ListDirectoryContactsResponse {
    return ListDirectoryContactsResponseFromJSONTyped(json, false);
}

export function ListDirectoryContactsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListDirectoryContactsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'is_external': json['is_external'],
        'data': ((json['data'] as Array<any>).map(DirectoryContactFromJSON)),
    };
}

export function ListDirectoryContactsResponseToJSON(json: any): ListDirectoryContactsResponse {
    return ListDirectoryContactsResponseToJSONTyped(json, false);
}

export function ListDirectoryContactsResponseToJSONTyped(value?: ListDirectoryContactsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'is_external': value['is_external'],
        'data': ((value['data'] as Array<any>).map(DirectoryContactToJSON)),
    };
}

